/* This file is automatically generated for @graphcommerce/magento-product/components/ProductPagePrice/ProductPagePriceTiers */

export * from './ProductPagePriceTiers'
import { Plugin as ConfigurableProductPagePriceTiers } from '@graphcommerce/magento-product-configurable/plugins/ConfigurableProductPage/ConfigurableProductPagePriceTiers'
import { ComponentProps } from 'react'
import { ProductPagePriceTiers as ProductPagePriceTiersBase } from './ProductPagePriceTiers'

/**
 * Interceptor for `<ProductPagePriceTiers/>` with these plugins:
 * 
 * - `@graphcommerce/magento-product-configurable/plugins/ConfigurableProductPage/ConfigurableProductPagePriceTiers`
 */
type ProductPagePriceTiersProps = ComponentProps<typeof ProductPagePriceTiersBase>

function ConfigurableProductPagePriceTiersInterceptor(props: ProductPagePriceTiersProps) {
  return <ConfigurableProductPagePriceTiers {...props} Prev={ProductPagePriceTiersBase} />
}
export const ProductPagePriceTiers = ConfigurableProductPagePriceTiersInterceptor
